export const REFUND_WALLET_STATE = 'refundWallet'

export const REFUND_WALLET_REQUEST = 'REFUND_WALLET_REQUEST'
export const REFUND_WALLET_SUCCESS = 'REFUND_WALLET_SUCCESS'
export const REFUND_WALLET_FAILURE = 'REFUND_WALLET_FAILURE'

export const STATUS_REFUND_WALLET_OK = 'STATUS_REFUND_WALLET_OK'
export const STATUS_REFUND_WALLET_NOT_OK = 'STATUS_REFUND_WALLET_NOT_OK'
